function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
import { Command, Plugin, icons } from '@ckeditor/ckeditor5-core/dist/index.js';
import { findOptimalInsertionRange, toWidget, Widget } from '@ckeditor/ckeditor5-widget/dist/index.js';
import { ButtonView, MenuBarMenuListItemButtonView } from '@ckeditor/ckeditor5-ui/dist/index.js';
import { logWarning, createElement } from '@ckeditor/ckeditor5-utils/dist/index.js';
/**
 * The insert HTML embed element command.
 *
 * The command is registered by {@link module:html-embed/htmlembedediting~HtmlEmbedEditing} as `'htmlEmbed'`.
 *
 * To insert an empty HTML embed element at the current selection, execute the command:
 *
 * ```ts
 * editor.execute( 'htmlEmbed' );
 * ```
 *
 * You can specify the initial content of a new HTML embed in the argument:
 *
 * ```ts
 * editor.execute( 'htmlEmbed', '<b>Initial content.</b>' );
 * ```
 *
 * To update the content of the HTML embed, select it in the model and pass the content in the argument:
 *
 * ```ts
 * editor.execute( 'htmlEmbed', '<b>New content of an existing embed.</b>' );
 * ```
 */

var HtmlEmbedCommand = /*#__PURE__*/function (_Command) {
  _inherits(HtmlEmbedCommand, _Command);

  var _super = _createSuper(HtmlEmbedCommand);

  function HtmlEmbedCommand() {
    _classCallCheck(this, HtmlEmbedCommand);

    return _super.apply(this, arguments);
  }

  _createClass(HtmlEmbedCommand, [{
    key: "refresh",
    value:
    /**
    * @inheritDoc
    */
    function refresh() {
      var model = this.editor.model;
      var schema = model.schema;
      var selection = model.document.selection;
      var selectedRawHtmlElement = getSelectedRawHtmlModelWidget(selection);
      this.isEnabled = isHtmlEmbedAllowedInParent(selection, schema, model);
      this.value = selectedRawHtmlElement ? selectedRawHtmlElement.getAttribute('value') || '' : null;
    }
    /**
    * Executes the command, which either:
    *
    * * creates and inserts a new HTML embed element if none was selected,
    * * updates the content of the HTML embed if one was selected.
    *
    * @fires execute
    * @param value When passed, the value (content) will be set on a new embed or a selected one.
    */

  }, {
    key: "execute",
    value: function execute(value) {
      var _this = this;

      var model = this.editor.model;
      var selection = model.document.selection;
      model.change(function (writer) {
        var htmlEmbedElement; // If the command has a non-null value, there must be some HTML embed selected in the model.

        if (_this.value !== null) {
          htmlEmbedElement = getSelectedRawHtmlModelWidget(selection);
        } else {
          htmlEmbedElement = writer.createElement('rawHtml');
          model.insertObject(htmlEmbedElement, null, null, {
            setSelection: 'on'
          });
        }

        writer.setAttribute('value', value, htmlEmbedElement);
      });
    }
  }]);

  return HtmlEmbedCommand;
}(Command);
/**
 * Checks if an HTML embed is allowed by the schema in the optimal insertion parent.
 */


function isHtmlEmbedAllowedInParent(selection, schema, model) {
  var parent = getInsertHtmlEmbedParent(selection, model);
  return schema.checkChild(parent, 'rawHtml');
}
/**
 * Returns a node that will be used to insert a html embed with `model.insertContent` to check if a html embed element can be placed there.
 */


function getInsertHtmlEmbedParent(selection, model) {
  var insertionRange = findOptimalInsertionRange(selection, model);
  var parent = insertionRange.start.parent;

  if (parent.isEmpty && !parent.is('rootElement')) {
    return parent.parent;
  }

  return parent;
}
/**
 * Returns the selected HTML embed element in the model, if any.
 */


function getSelectedRawHtmlModelWidget(selection) {
  var selectedElement = selection.getSelectedElement();

  if (selectedElement && selectedElement.is('element', 'rawHtml')) {
    return selectedElement;
  }

  return null;
}
/**
 * The HTML embed editing feature.
 */


var HtmlEmbedEditing = /*#__PURE__*/function (_Plugin) {
  _inherits(HtmlEmbedEditing, _Plugin);

  var _super2 = _createSuper(HtmlEmbedEditing);

  /**
  * @inheritDoc
  */
  function HtmlEmbedEditing(editor) {
    var _this2;

    _classCallCheck(this, HtmlEmbedEditing);

    _this2 = _super2.call(this, editor);
    _this2._widgetButtonViewReferences = new Set();
    editor.config.define('htmlEmbed', {
      showPreviews: false,
      sanitizeHtml: function sanitizeHtml(rawHtml) {
        /**
        * When using the HTML embed feature with the `config.htmlEmbed.showPreviews` set to `true`, it is strongly recommended to
        * define a sanitize function that will clean up the input HTML in order to avoid XSS vulnerability.
        *
        * For a detailed overview, check the {@glink features/html/html-embed HTML embed feature} documentation.
        *
        * @error html-embed-provide-sanitize-function
        */
        logWarning('html-embed-provide-sanitize-function');
        return {
          html: rawHtml,
          hasChanged: false
        };
      }
    });
    return _this2;
  }
  /**
  * @inheritDoc
  */


  _createClass(HtmlEmbedEditing, [{
    key: "init",
    value: function init() {
      var editor = this.editor;
      var schema = editor.model.schema;
      schema.register('rawHtml', {
        inheritAllFrom: '$blockObject',
        allowAttributes: ['value']
      });
      editor.commands.add('htmlEmbed', new HtmlEmbedCommand(editor));

      this._setupConversion();
    }
    /**
    * Prepares converters for the feature.
    */

  }, {
    key: "_setupConversion",
    value: function _setupConversion() {
      var editor = this.editor;
      var t = editor.t;
      var _view = editor.editing.view;
      var widgetButtonViewReferences = this._widgetButtonViewReferences;
      var htmlEmbedConfig = editor.config.get('htmlEmbed'); // Destroy UI buttons created for widgets that have been removed from the view document (e.g. in the previous conversion).
      // This prevents unexpected memory leaks from UI views.

      this.editor.editing.view.on('render', function () {
        var _iterator = _createForOfIteratorHelper(widgetButtonViewReferences),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var buttonView = _step.value;

            if (buttonView.element && buttonView.element.isConnected) {
              return;
            }

            buttonView.destroy();
            widgetButtonViewReferences.delete(buttonView);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }, {
        priority: 'lowest'
      }); // Register div.raw-html-embed as a raw content element so all of it's content will be provided
      // as a view element's custom property while data upcasting.

      editor.data.registerRawContentMatcher({
        name: 'div',
        classes: 'raw-html-embed'
      });
      editor.conversion.for('upcast').elementToElement({
        view: {
          name: 'div',
          classes: 'raw-html-embed'
        },
        model: function model(viewElement, _ref) {
          var writer = _ref.writer;
          // The div.raw-html-embed is registered as a raw content element,
          // so all it's content is available in a custom property.
          return writer.createElement('rawHtml', {
            value: viewElement.getCustomProperty('$rawContent')
          });
        }
      });
      editor.conversion.for('dataDowncast').elementToElement({
        model: 'rawHtml',
        view: function view(modelElement, _ref2) {
          var writer = _ref2.writer;
          return writer.createRawElement('div', {
            class: 'raw-html-embed'
          }, function (domElement) {
            domElement.innerHTML = modelElement.getAttribute('value') || '';
          });
        }
      });
      editor.conversion.for('editingDowncast').elementToStructure({
        model: {
          name: 'rawHtml',
          attributes: ['value']
        },
        view: function view(modelElement, _ref3) {
          var writer = _ref3.writer;
          var domContentWrapper;
          var state;
          var props;
          var viewContentWrapper = writer.createRawElement('div', {
            class: 'raw-html-embed__content-wrapper'
          }, function (domElement) {
            domContentWrapper = domElement;
            renderContent({
              editor: editor,
              domElement: domElement,
              state: state,
              props: props
            }); // Since there is a `data-cke-ignore-events` attribute set on the wrapper element in the editable mode,
            // the explicit `mousedown` handler on the `capture` phase is needed to move the selection onto the whole
            // HTML embed widget.

            domContentWrapper.addEventListener('mousedown', function () {
              if (state.isEditable) {
                var model = editor.model;
                var selectedElement = model.document.selection.getSelectedElement(); // Move the selection onto the whole HTML embed widget if it's currently not selected.

                if (selectedElement !== modelElement) {
                  model.change(function (writer) {
                    return writer.setSelection(modelElement, 'on');
                  });
                }
              }
            }, true);
          }); // API exposed on each raw HTML embed widget so other features can control a particular widget.

          var rawHtmlApi = {
            makeEditable: function makeEditable() {
              state = Object.assign({}, state, {
                isEditable: true
              });
              renderContent({
                domElement: domContentWrapper,
                editor: editor,
                state: state,
                props: props
              });

              _view.change(function (writer) {
                writer.setAttribute('data-cke-ignore-events', 'true', viewContentWrapper);
              }); // This could be potentially pulled to a separate method called focusTextarea().


              domContentWrapper.querySelector('textarea').focus();
            },
            save: function save(newValue) {
              // If the value didn't change, we just cancel. If it changed,
              // it's enough to update the model – the entire widget will be reconverted.
              if (newValue !== state.getRawHtmlValue()) {
                editor.execute('htmlEmbed', newValue);
                editor.editing.view.focus();
              } else {
                this.cancel();
              }
            },
            cancel: function cancel() {
              state = Object.assign({}, state, {
                isEditable: false
              });
              renderContent({
                domElement: domContentWrapper,
                editor: editor,
                state: state,
                props: props
              });
              editor.editing.view.focus();

              _view.change(function (writer) {
                writer.removeAttribute('data-cke-ignore-events', viewContentWrapper);
              });
            }
          };
          state = {
            showPreviews: htmlEmbedConfig.showPreviews,
            isEditable: false,
            getRawHtmlValue: function getRawHtmlValue() {
              return modelElement.getAttribute('value') || '';
            }
          };
          props = {
            sanitizeHtml: htmlEmbedConfig.sanitizeHtml,
            textareaPlaceholder: t('Paste raw HTML here...'),
            onEditClick: function onEditClick() {
              rawHtmlApi.makeEditable();
            },
            onSaveClick: function onSaveClick(newValue) {
              rawHtmlApi.save(newValue);
            },
            onCancelClick: function onCancelClick() {
              rawHtmlApi.cancel();
            }
          };
          var viewContainer = writer.createContainerElement('div', {
            class: 'raw-html-embed',
            'data-html-embed-label': t('HTML snippet'),
            dir: editor.locale.uiLanguageDirection
          }, viewContentWrapper);
          writer.setCustomProperty('rawHtmlApi', rawHtmlApi, viewContainer);
          writer.setCustomProperty('rawHtml', true, viewContainer);
          return toWidget(viewContainer, writer, {
            label: t('HTML snippet'),
            hasSelectionHandle: true
          });
        }
      });

      function renderContent(_ref4) {
        var editor = _ref4.editor,
            domElement = _ref4.domElement,
            state = _ref4.state,
            props = _ref4.props;
        // Remove all children;
        domElement.textContent = '';
        var domDocument = domElement.ownerDocument;
        var domTextarea;

        if (state.isEditable) {
          var textareaProps = {
            isDisabled: false,
            placeholder: props.textareaPlaceholder
          };
          domTextarea = createDomTextarea({
            domDocument: domDocument,
            state: state,
            props: textareaProps
          });
          domElement.append(domTextarea);
        } else if (state.showPreviews) {
          var previewContainerProps = {
            sanitizeHtml: props.sanitizeHtml
          };
          domElement.append(createPreviewContainer({
            domDocument: domDocument,
            state: state,
            props: previewContainerProps,
            editor: editor
          }));
        } else {
          var _textareaProps = {
            isDisabled: true,
            placeholder: props.textareaPlaceholder
          };
          domElement.append(createDomTextarea({
            domDocument: domDocument,
            state: state,
            props: _textareaProps
          }));
        }

        var buttonsWrapperProps = {
          onEditClick: props.onEditClick,
          onSaveClick: function onSaveClick() {
            props.onSaveClick(domTextarea.value);
          },
          onCancelClick: props.onCancelClick
        };
        domElement.prepend(createDomButtonsWrapper({
          editor: editor,
          domDocument: domDocument,
          state: state,
          props: buttonsWrapperProps
        }));
      }

      function createDomButtonsWrapper(_ref5) {
        var editor = _ref5.editor,
            domDocument = _ref5.domDocument,
            state = _ref5.state,
            props = _ref5.props;
        var domButtonsWrapper = createElement(domDocument, 'div', {
          class: 'raw-html-embed__buttons-wrapper'
        });

        if (state.isEditable) {
          var saveButtonView = createUIButton(editor, 'save', props.onSaveClick);
          var cancelButtonView = createUIButton(editor, 'cancel', props.onCancelClick);
          domButtonsWrapper.append(saveButtonView.element, cancelButtonView.element);
          widgetButtonViewReferences.add(saveButtonView).add(cancelButtonView);
        } else {
          var editButtonView = createUIButton(editor, 'edit', props.onEditClick);
          domButtonsWrapper.append(editButtonView.element);
          widgetButtonViewReferences.add(editButtonView);
        }

        return domButtonsWrapper;
      }

      function createDomTextarea(_ref6) {
        var domDocument = _ref6.domDocument,
            state = _ref6.state,
            props = _ref6.props;
        var domTextarea = createElement(domDocument, 'textarea', {
          placeholder: props.placeholder,
          class: 'ck ck-reset ck-input ck-input-text raw-html-embed__source'
        });
        domTextarea.disabled = props.isDisabled;
        domTextarea.value = state.getRawHtmlValue();
        return domTextarea;
      }

      function createPreviewContainer(_ref7) {
        var editor = _ref7.editor,
            domDocument = _ref7.domDocument,
            state = _ref7.state,
            props = _ref7.props;
        var sanitizedOutput = props.sanitizeHtml(state.getRawHtmlValue());
        var placeholderText = state.getRawHtmlValue().length > 0 ? t('No preview available') : t('Empty snippet content');
        var domPreviewPlaceholder = createElement(domDocument, 'div', {
          class: 'ck ck-reset_all raw-html-embed__preview-placeholder'
        }, placeholderText);
        var domPreviewContent = createElement(domDocument, 'div', {
          class: 'raw-html-embed__preview-content',
          dir: editor.locale.contentLanguageDirection
        }); // Creating a contextual document fragment allows executing scripts when inserting into the preview element.
        // See: #8326.

        var domRange = domDocument.createRange();
        var domDocumentFragment = domRange.createContextualFragment(sanitizedOutput.html);
        domPreviewContent.appendChild(domDocumentFragment);
        var domPreviewContainer = createElement(domDocument, 'div', {
          class: 'raw-html-embed__preview'
        }, [domPreviewPlaceholder, domPreviewContent]);
        return domPreviewContainer;
      }
    }
  }], [{
    key: "pluginName",
    get:
    /**
    * Keeps references to {@link module:ui/button/buttonview~ButtonView edit, save, and cancel} button instances created for
    * each widget so they can be destroyed if they are no longer in DOM after the editing view was re-rendered.
    */

    /**
    * @inheritDoc
    */
    function get() {
      return 'HtmlEmbedEditing';
    }
  }]);

  return HtmlEmbedEditing;
}(Plugin);
/**
 * Returns a UI button view that can be used in conversion.
 */


function createUIButton(editor, type, onClick) {
  var t = editor.locale.t;
  var buttonView = new ButtonView(editor.locale);
  var command = editor.commands.get('htmlEmbed');
  buttonView.set({
    class: "raw-html-embed__".concat(type, "-button"),
    icon: icons.pencil,
    tooltip: true,
    tooltipPosition: editor.locale.uiLanguageDirection === 'rtl' ? 'e' : 'w'
  });
  buttonView.render();

  if (type === 'edit') {
    buttonView.set({
      icon: icons.pencil,
      label: t('Edit source')
    });
    buttonView.bind('isEnabled').to(command);
  } else if (type === 'save') {
    buttonView.set({
      icon: icons.check,
      label: t('Save changes')
    });
    buttonView.bind('isEnabled').to(command);
  } else {
    buttonView.set({
      icon: icons.cancel,
      label: t('Cancel')
    });
  }

  buttonView.on('execute', onClick);
  return buttonView;
}
/**
 * The HTML embed UI plugin.
 */


var HtmlEmbedUI = /*#__PURE__*/function (_Plugin2) {
  _inherits(HtmlEmbedUI, _Plugin2);

  var _super3 = _createSuper(HtmlEmbedUI);

  function HtmlEmbedUI() {
    _classCallCheck(this, HtmlEmbedUI);

    return _super3.apply(this, arguments);
  }

  _createClass(HtmlEmbedUI, [{
    key: "init",
    value:
    /**
    * @inheritDoc
    */
    function init() {
      var _this3 = this;

      var editor = this.editor;
      var locale = editor.locale;
      var t = locale.t; // Add the `htmlEmbed` button to feature components.

      editor.ui.componentFactory.add('htmlEmbed', function () {
        var buttonView = _this3._createButton(ButtonView);

        buttonView.set({
          tooltip: true,
          label: t('Insert HTML')
        });
        return buttonView;
      });
      editor.ui.componentFactory.add('menuBar:htmlEmbed', function () {
        var buttonView = _this3._createButton(MenuBarMenuListItemButtonView);

        buttonView.set({
          label: t('HTML snippet')
        });
        return buttonView;
      });
    }
    /**
    * Creates a button for html embed command to use either in toolbar or in menu bar.
    */

  }, {
    key: "_createButton",
    value: function _createButton(ButtonClass) {
      var editor = this.editor;
      var command = editor.commands.get('htmlEmbed');
      var view = new ButtonClass(editor.locale);
      view.set({
        icon: icons.html
      });
      view.bind('isEnabled').to(command, 'isEnabled'); // Execute the command.

      this.listenTo(view, 'execute', function () {
        editor.execute('htmlEmbed');
        editor.editing.view.focus();
        var rawHtmlApi = editor.editing.view.document.selection.getSelectedElement().getCustomProperty('rawHtmlApi');
        rawHtmlApi.makeEditable();
      });
      return view;
    }
  }], [{
    key: "pluginName",
    get:
    /**
    * @inheritDoc
    */
    function get() {
      return 'HtmlEmbedUI';
    }
  }]);

  return HtmlEmbedUI;
}(Plugin);
/**
 * The HTML embed feature.
 *
 * It allows inserting HTML snippets directly into the editor.
 *
 * For a detailed overview, check the {@glink features/html/html-embed HTML embed feature} documentation.
 */


var HtmlEmbed = /*#__PURE__*/function (_Plugin3) {
  _inherits(HtmlEmbed, _Plugin3);

  var _super4 = _createSuper(HtmlEmbed);

  function HtmlEmbed() {
    _classCallCheck(this, HtmlEmbed);

    return _super4.apply(this, arguments);
  }

  _createClass(HtmlEmbed, null, [{
    key: "requires",
    get:
    /**
    * @inheritDoc
    */
    function get() {
      return [HtmlEmbedEditing, HtmlEmbedUI, Widget];
    }
    /**
    * @inheritDoc
    */

  }, {
    key: "pluginName",
    get: function get() {
      return 'HtmlEmbed';
    }
  }]);

  return HtmlEmbed;
}(Plugin);

export { HtmlEmbed, HtmlEmbedEditing, HtmlEmbedUI };